import { create } from 'zustand';
import type {
  AgentUIEventName,
  CaptureEventFn,
  EventProperties,
} from '@config/events';

interface EventStore {
  captureEvent?: CaptureEventFn;
  setCaptureEvent: (fn: CaptureEventFn) => void;
  dispatchEvent: (event: AgentUIEventName, payload?: EventProperties) => void;
}

export const useEventStore = create<EventStore>((set, get) => ({
  captureEvent: undefined,

  setCaptureEvent: (fn) => {
    set({ captureEvent: fn });
  },

  dispatchEvent: (type, payload) => {
    const { captureEvent } = get();
    if (!captureEvent) return;

    captureEvent(type, payload);
  },
}));
